const createRoutes = () => [
    {
        path: '/sweattube/:path*',
        exact: true,
        component: require('./pages/SweatTubeLink').default,
    },
];
export default createRoutes;
